/**
 * @module SequentialReveal
 * @description Reveals child elements one by one after Monarch finishes loading
 */
import { useEffect, useState, Children } from "react";
import { useMonarch } from "@redventures/cohesion-utils-react";
import styles from "./index.module.css";

const SequentialReveal = ({ children, delayMs = 150 }) => {
  const { isLoading } = useMonarch();
  const [visibleCount, setVisibleCount] = useState(0);
  const items = Children.toArray(children);

  useEffect(() => {
    if (isLoading) {
      setVisibleCount(0);
      return;
    }

    let count = 0;
    const interval = setInterval(() => {
      count += 1;
      setVisibleCount(count);
      if (count >= items.length) clearInterval(interval);
    }, delayMs);

    return () => clearInterval(interval);
  }, [isLoading, items.length, delayMs]);

  return (
    <>
      {items.map((child, index) => (
        <div
          key={child.key || index}
          className={`${styles.item} ${index < visibleCount ? styles.visible : ""}`}
        >
          {child}
        </div>
      ))}
    </>
  );
};

export default SequentialReveal;
